import InfoLabel from '@/components/InfoLabel';
import usePureState from '@/hooks/usePureState';
import IQuestion, { ILocationQuestionOptions, IQuestionLocation, IQuestionType } from '@/types/IQuestion';
import { AccordionItem, AccordionPanel, FormControl, Input } from '@chakra-ui/react';
import { Options, Select, SingleValue } from 'chakra-react-select';
import { ChangeEvent, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Header from './components/Header';
import QuestionOptionsSection from './components/QuestionOptionsSection';

export type IQuestionLocationProps = IQuestionLocation & {
	isLoading: boolean;
	onChange: (q: IQuestion) => void;
	onDelete: (q: { id: string }) => void;
};

export const DEFAULT_QUESTION_LOCATION_DATA: ILocationQuestionOptions = [
	{ type: 'BookerPhoneLocationOption' },
	{ type: 'FixedLocationOption' },
	{ type: 'GoogleMeetLocationOption' },
	{ type: 'MicrosoftOutlookLocationOption' },
];

export default function QuestionLocation(props: IQuestionLocationProps) {
	const { t } = useTranslation();

	const options = useMemo<Options<{ label: string; value: IQuestionType }>>(
		() => [
			// { label: t('Text') as string, value: 'text' },
			// { label: t('Phone number') as string, value: 'phone' },
			{ label: t('Location') as string, value: 'LOCATION' },
		],
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const { state, dispatch } = usePureState<{ allowedOptions: ILocationQuestionOptions }>({
		allowedOptions: props.allowedOptions || DEFAULT_QUESTION_LOCATION_DATA,
	});

	const form = useForm({
		defaultValues: {
			id: props.id,
			label: props.label,
			type: props.type,
			// TODO: El fucking odin no implemento esta movida
			required: true,
		},
	});

	function handleLabelBlur(e: ChangeEvent<HTMLInputElement>) {
		form.setValue('label', e.target.value);
		props.onChange({ ...form.getValues(), label: e.target.value, allowedOptions: state.allowedOptions });
	}

	function handleQuestionTypeChange(e: SingleValue<{ label: string; value: IQuestionType }>) {
		if (!e) {
			return;
		}
		// @ts-ignore We can change the question type
		form.setValue('type', e.value);
		switch (e.value) {
			case 'LOCATION':
				return props.onChange({ ...form.getValues(), type: e.value, allowedOptions: state.allowedOptions });
			case 'PHONE':
			case 'TEXT':
				return props.onChange({ ...form.getValues(), type: e.value });
		}
	}

	function handleChange(value: ILocationQuestionOptions) {
		dispatch({ allowedOptions: value });
		return props.onChange({ ...form.getValues(), allowedOptions: value });
	}

	return (
		<AccordionItem>
			<Header {...props} />

			<AccordionPanel pb={4}>
				<FormControl>
					<InfoLabel text={t('Label')} help={t('Tell the booker which data to introduce. Name, email, phone...')} />
					<Input isDisabled={props.isLoading} size="sm" {...form.register('label')} onBlur={handleLabelBlur} />
				</FormControl>

				<FormControl>
					<InfoLabel mt="2" text={t('Type')} help={t('The question type')} />
					<Select
						{...form.register('type')}
						defaultValue={options.find((op) => op.value === form.getValues('type'))}
						isDisabled={props.isLoading}
						menuPosition="fixed"
						onChange={handleQuestionTypeChange}
						options={options}
						size="sm"
					/>
				</FormControl>
				<QuestionOptionsSection value={state.allowedOptions} onChange={handleChange} isLoading={props.isLoading} />
			</AccordionPanel>
		</AccordionItem>
	);
}
